import { put, takeLatest, call, select } from "redux-saga/effects";
import { USERS_PAGE_LOAD, usersLoaded } from "../../actions/users";
import { role as roleSelector, ADMIN } from "../../selectors/auth";
import listSecurityCoverageUsers from "../../../../../backend/oncall/administration/users/list";
import listPartnerUsers from "../../../../../backend/oncall/partners/users/list";
import { showErrorPage } from "../../../../../actions/ui/location";

const usersPageLoadSaga = function*(action) {
  try {
    const role = yield select(roleSelector);
    const listUsers =
      role === ADMIN ? listSecurityCoverageUsers : listPartnerUsers;
    const result = yield call(listUsers);
    yield put(usersLoaded(result.users));
  } catch (ignore) {
    yield put(showErrorPage());
  }
};

export default function*() {
  //noinspection JSCheckFunctionSignatures
  yield takeLatest(USERS_PAGE_LOAD, usersPageLoadSaga);
}



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/sagas/users/list-page-load.js